import { render } from "./quotation-modal.vue?vue&type=template&id=3c82140f&scoped=true"
import script from "./quotation-modal.vue?vue&type=script&lang=js"
export * from "./quotation-modal.vue?vue&type=script&lang=js"

import "./quotation-modal.vue?vue&type=style&index=0&id=3c82140f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c82140f"]])

export default __exports__